import { Box, Loader, PulseAnimation } from '@wix/design-system';
import { HintSmall, LockLockedSmall, StatusAlertFilledSmall, TimeSmall } from '@wix/wix-ui-icons-common';
import React, { useCallback, useEffect, useState } from 'react';
import { RuleListStatus } from '../../types';
import { dataHooks } from '../../utils/datahooks';
import { usePreviousState } from '../../utils/use-previous-state';
import { CompletedTaskIcon } from './completed-task-icon';
export const PrefixStatusIcon = _ref => {
  let {
    ruleResult
  } = _ref;
  const {
    onStatusChange,
    status,
    id,
    isLoading
  } = ruleResult;
  const [isPulseActive, setIsPulseActive] = useState(false);
  const prevStatus = usePreviousState(status);
  useEffect(() => {
    if (prevStatus !== undefined && prevStatus !== status) {
      if (prevStatus === RuleListStatus.failed && status === RuleListStatus.passed) {
        setIsPulseActive(true);
      }
      onStatusChange == null || onStatusChange();
    }
  }, [prevStatus, setIsPulseActive, status, onStatusChange, id]);
  const passedIcon = useCallback(() => {
    return /*#__PURE__*/React.createElement(Box, {
      padding: "2px"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        position: 'relative',
        zIndex: 2
      }
    }, /*#__PURE__*/React.createElement(PulseAnimation, {
      active: isPulseActive,
      borderRadius: "50%",
      color: "G10",
      delay: "300ms",
      loop: false,
      onEnd: () => setIsPulseActive(false)
    }, /*#__PURE__*/React.createElement(Box, {
      dataHook: dataHooks.rulesListPrefixIconComplete
    }, /*#__PURE__*/React.createElement(CompletedTaskIcon, null)))));
  }, [isPulseActive]);
  const failedIcon = () => {
    return /*#__PURE__*/React.createElement(Box, {
      color: "R10",
      dataHook: dataHooks.rulesListPrefixIconFailed
    }, /*#__PURE__*/React.createElement(StatusAlertFilledSmall, null));
  };
  const loadingIcon = () => {
    return /*#__PURE__*/React.createElement(Box, {
      dataHook: dataHooks.rulesListPrefixIconLoading
    }, /*#__PURE__*/React.createElement(Loader, {
      size: "tiny"
    }));
  };
  const disabledIcon = () => {
    return /*#__PURE__*/React.createElement(Box, {
      dataHook: dataHooks.rulesListPrefixIconLoading
    }, /*#__PURE__*/React.createElement(LockLockedSmall, null));
  };
  const recommendationIcon = () => {
    return /*#__PURE__*/React.createElement(Box, {
      color: "B10",
      dataHook: dataHooks.rulesListPrefixIconRecommendation
    }, /*#__PURE__*/React.createElement(HintSmall, {
      size: "18px"
    }));
  };
  const pendingIcon = () => {
    return /*#__PURE__*/React.createElement(Box, {
      color: "Y20",
      dataHook: dataHooks.rulesListPrefixIconPending
    }, /*#__PURE__*/React.createElement(TimeSmall, {
      size: "18px"
    }));
  };
  const getStatusIcon = useCallback(() => {
    if (isLoading) {
      return loadingIcon();
    }
    switch (status) {
      case RuleListStatus.passed:
        return passedIcon();
      case RuleListStatus.failed:
        return failedIcon();
      case RuleListStatus.error:
        // TODO: add an error icon if needed
        return failedIcon();
      case RuleListStatus.disabled:
        return disabledIcon();
      case RuleListStatus.recommendation:
        return recommendationIcon();
      case RuleListStatus.pending:
        return pendingIcon();
      default:
        return null;
    }
  }, [isLoading, passedIcon, status]);
  return /*#__PURE__*/React.createElement(Box, {
    paddingTop: "3px"
  }, getStatusIcon());
};
//# sourceMappingURL=prefix-status-icon.js.map